import{styled}from'styled-components';export const HiddenCheckboxFieldWrapper=styled.div.withConfig({componentId:"sc-1jcfjz5-0"})(["display:none;"]);